import styled, {css} from 'styled-components';

import BaseDropdown, {Head as BaseHead, Overlay} from '../Dropdown';
import {mixins} from '../styles';
import {TSize} from '../types';

type TDropdownProps = {
  hasMarginLeft?: boolean;
  hasMarginRight?: boolean;
};

export const Dropdown = styled(BaseDropdown)<TDropdownProps>`
  display: inline-block;
  ${({theme: {spacing}, hasMarginLeft, hasMarginRight}) => css`
    margin: 0 ${hasMarginRight ? spacing.s1 : 0} 0 ${hasMarginLeft ? spacing.s1 : 0};
  `}
`;

const getIconSize = (size: TSize) => {
  switch (size) {
    case 'XL':
      return '28px';
    case 'L':
      return '24px';
    case 'M':
      return '20px';
    case 'S':
      return '16px';
    case 'XS':
      return '12px';
  }
};

export const HeadIcon = styled.svg<{size: TSize}>`
  display: inline-block;

  ${({theme: {branding, animation}, size}) => css`
    ${mixins.round(getIconSize(size))};
    color: ${branding.content.secondary};
    transition: color ${animation.duration}ms;

    &:hover {
      color: ${branding.content.primary};
    }
  `}
`;

export const InfoDropdownOverlay = styled(Overlay)`
  width: 300px;
  min-width: 50px;

  ${({theme}: TTheme) => css`
    z-index: ${theme.zIndex.infoDropdown};
    border-radius: ${theme.borderRadius.br2};
    background-color: ${theme.palette.grey700};
    color: ${theme.palette.grey100};
    box-shadow: none;

    a {
      text-decoration: underline;
      color: currentColor;
    }

    &::before {
      box-shadow: none;
      border-color: ${theme.palette.grey700} ${theme.palette.grey700} transparent transparent;
    }
  `}
`;

export const InfoDropdownContent = styled.div`
  ${mixins.f2};
  line-height: 16px;
  white-space: pre-line;
  padding: ${({theme}) => theme.spacing.s4};
`;

export const InfoDropdownHead = styled(BaseHead)`
  display: flex;
  cursor: help;
`;
